<template>
  <div v-if="showquan == true">
    <div class="act">
      <ul @click="gocoupon">
        <li>
          <img src="/static/images/c1.png">
        </li>
        <li>
          <img src="/static/images/c2.png">
        </li>
      </ul>
<!--      <img src="../../assets/images/skintest1.png" @click="handleSkinResult">-->
    </div>
  </div>
</template>

<script>
import {getCookie, isWeixin} from '../../assets/common/js/config'
import { customRequestAjax } from '@/axiosApi'

export default {
  name: 'skinTest',
  data() {
    return {
      show: true,
      skinInfo: {},
      showquan: false
    }
  },
  props: {
    page: {
      type: String,
      default: ''
    }
  },
  mounted () {
    // this.getquan()
  },
  methods: {
    close: function () {
      var that = this
      that.$dialog.confirm({
        title: '关闭后将不再显示',
        message: '关闭后可前往“我的”点击头像查看',
        className: 'collect_button_alert collect_button_skin',
        cancelButtonColor: '#FC0324',
        confirmButtonColor: '#FFFCFC'
      }).then(() => {
      }).catch(() => {
        // on cancel
      })
    },
    // getquan () {
    //   var url = 'Wxmall/Coupon/getCouponActStatus'
    //   customRequestAjax(url).then((res) => {
    //     if (res.data.code === 200) {
    //       if (res.data.data.act_status == 1) {
    //         this.showquan = true
    //       }
    //     }
    //   })
    // },
    gocoupon: function () {
      this.$router.push('/getcoupon')
    }
  }
}
</script>

<style scoped lang="scss">
  .act {
    width: 100%;
    position: relative;
    padding: .1rem .11rem 0;
    margin-bottom: 0.1rem;
    /*border-top: solid .1rem #F5F5F5;*/
    background: transparent;
    ul{
     display: flex;
      align-items: center;
      justify-content: space-between;
      li{
        width: 49%;
        img{
          width: 100%;
        }
      }
    }
  }
</style>
<style lang="scss">
  .collect_button_skin {
    .van-dialog__content {
      padding-top: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/coupon.vue